function formatCurrency(number, fractionalDigits, currency) {
    if (number === undefined || number == null) {
        return ""
    }
    return Number(number).toLocaleString('hu-HU', {style: 'currency', currency , minimumFractionDigits: 0, maximumFractionDigits: fractionalDigits})
}

export default formatCurrency;
